import './App.css';
import Body from "./Body/Body.js"

function App() {
  return (
	<>
		<div className="radian_rectangle" ></div>
		<div className='working-space'>
			<Body/>
		</div>
		{/*<div className="radian_rectangle-bottom" ></div>*/}

	</>
  )
}

export default App;
